import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import {
  AuthPasskeyChallengeRegisterRequestBody,
  AuthPasskeyChallengeRegisterResponse,
} from "./types";

export class AuthPasskeyChallengeRegisterAPI extends BaseAPI<
  AuthPasskeyChallengeRegisterRequestBody,
  AuthPasskeyChallengeRegisterResponse
> {
  protected route = ApiRoutes.auth.passkey_challenge_register;
  protected method = RequestMethod.POST;
}
